import { gql } from '@apollo/client';

export const CREATE_IMAGE_UPLOAD = gql`
    mutation CreateImageUpload($fileName: String!) {
        createImageUpload(fileName: $fileName) {
            image { id url }
            uploadUrl
        }
    }
`;
